import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 21v-6m0 -6v-1a4 4 0 1 1 4 4h-13","key":"svg-0"}],["path",{"d":"M8 16l-4 -4l4 -4","key":"svg-1"}]]

/**
 * IconArrowLoopLeft2
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctbG9vcC1sZWZ0LTIiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEzIDIxdi02bTAgLTZ2LTFhNCA0IDAgMSAxIDQgNGgtMTMiIC8+CiAgPHBhdGggZD0iTTggMTZsLTQgLTRsNCAtNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-loop-left-2
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowLoopLeft2 = createReactComponent('outline', 'arrow-loop-left-2', 'ArrowLoopLeft2', __iconNode);

export default IconArrowLoopLeft2;